export default __webpack_public_path__ + "static/media/Primary-VideoLink.1bf6b6e8.svg";